import { COLORS } from "../../../styles/variables";

export const TabsStyle = {
    position: 'relative',
    '& .MuiTabScrollButton-root': {
        position: 'absolute',
        zIndex: 1,
        height: '100%',
        opacity: 1,
        '&.Mui-disabled': {
            opacity: 0,
        },
    },
    '& .MuiTabScrollButton-root:first-of-type': { 
        background: `linear-gradient(to right, ${COLORS.SNOW_DRIFT} 60%, transparent 100%)`,
        left: 0,
    },
    '& .MuiTabScrollButton-root:last-of-type': { 
        background: `linear-gradient(to left, ${COLORS.SNOW_DRIFT} 60%, transparent 100%)`,
        right: 0,
    },
}
